<template>
    <v-dialog transition="scale-transition" origin="center center" max-width="460" v-model="dialogDeposit"
        content-class="deposit-withdraw-popup marketingPopup">
        <template v-slot:activator="{ on, attrs }">
            <span class="text-decoration-none" v-bind="attrs" v-on="on">
                {{ localStatus === 1 ? "Block User" : "Unblock User" }}
            </span>
        </template>
        <v-card class="rounded-0 pa-7" :class="$vuetify.theme.dark ? 'blue-darken-1' : 'white-lighten-5'">
            <v-card-title class="pb-3 text-left justify-start pl-3">
                Change User Block Status
            </v-card-title>
            <v-card-subtitle class="mt-0 pl-3 pb-0 pr-10 text--ash">
                You Can Update User Block Status From Here
            </v-card-subtitle>
            <v-card-actions>
                <v-row dense>
                    <v-col cols="12 mt-4">
                        <v-btn tile @click="updateUser" elevation="0" class="text-capitalize btn-account mr-3 px-sm-8"
                            color="greenMain">{{ localStatus === 1 ? "Block User" : "Unblock User" }}</v-btn>
                        <v-btn tile color="#FF567F" @click="dialogDeposit = false" elevation="0"
                            class="text-capitalize btn-account px-sm-8">Cancel</v-btn>
                    </v-col>
                </v-row>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { BLOCKEDUSER__ACTIONS, REGISTERUSERDETAILS__ACTIONS } from "@/store/action-types";

export default {
    data() {
        return {
            userId: "",
            dialogDeposit: false,
            localStatus: null, // Local state to track block status
        };
    },
    computed: {
        ...mapState("reguserdetails", ["personalinfo"])
    },
    watch: {
        // Watch the personalinfo state to sync localStatus with Vuex state when it changes
        personalinfo: {
            handler(newInfo) {
                this.localStatus = newInfo.status;
            },
            immediate: true // This ensures it runs when the component is mounted
        }
    },
    methods: {
        ...mapActions("reguserdetails", [REGISTERUSERDETAILS__ACTIONS.REGPERSONALINFO]),
        ...mapActions("blockedusers", [BLOCKEDUSER__ACTIONS.UNBLOCKUSER]),

        async updateUser() {
            // Toggle the block status based on the current status
            const newStatus = this.localStatus === 1 ? 0 : 1;

            // Simulate calling the Vuex action to update block status in the backend
            await this[BLOCKEDUSER__ACTIONS.UNBLOCKUSER]({
                id: this.userId,
                status: newStatus
            });

            // Update the local state immediately to reflect the change on the UI
            this.localStatus = newStatus;

            // Close the dialog
            this.dialogDeposit = false;
        },
    },
    async mounted() {
        // Fetch user details when the component is mounted
        this.userId = this.$route.params.id;
        await this[REGISTERUSERDETAILS__ACTIONS.REGPERSONALINFO](this.userId);
    },
};
</script>
